"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.transform = void 0;
const FORWARDED_HOST = "x-forwarded-host";
const HOST = "host";
const BASE_HEADERS = {
    accept: "application/json",
};
function inferOrigin(incomingHeaders, defaultOrigin) {
    const host = incomingHeaders[FORWARDED_HOST] || incomingHeaders[HOST];
    if (host && typeof host === "string") {
        return host.includes("localhost") ? `http://${host}` : `https://${host}`;
    }
    return defaultOrigin;
}
function transformIncoming(incomingHeaders, allowedHeaders, defaultOrigin) {
    // only take the allowed headers
    const filtered = Object.fromEntries(Object.entries(incomingHeaders).filter(([key, value]) => allowedHeaders.includes(key) && typeof value === "string"));
    const originFromHost = inferOrigin(incomingHeaders, defaultOrigin);
    const origin = incomingHeaders["origin"] || originFromHost;
    return {
        headers: {
            ...BASE_HEADERS,
            ...filtered,
            origin,
        },
    };
}
/**
 * Takes the incoming HTTP headers and transforms them according to the following:
 *
 * 1. Filters the incoming headers against the supplied allow list
 * 2. Sets the origin header according to the following:
 *        - if origin is already set, use that
 *        - if unset, first try x-forwarded-host
 *        - if x-forwarded-host is unset, try host
 *        - if none of the above is set, return the default origin
 *
 * @param incomingHeaders the original headers
 * @param allowedHeaders the list of allowed headers to keep
 * @param defaultOrigin the default origin in case of origin not being set, e.g. https://www.snapchat.com
 */
function transform(incomingHeaders, allowedHeaders, defaultOrigin) {
    if (incomingHeaders) {
        return transformIncoming(incomingHeaders, allowedHeaders, defaultOrigin);
    }
    return {
        headers: {
            ...BASE_HEADERS,
            origin: defaultOrigin,
        },
    };
}
exports.transform = transform;
//# sourceMappingURL=transformation.js.map